import React from 'react';
import UnifiedMessagingPage from './UnifiedMessagingPage';

/**
 * Wrapper component that renders the messaging page without secure URL redirection.
 * Uses the global MessagingProvider from App.jsx — do NOT nest another one here.
 */
const MessagingPageWrapper = () => {
  return <UnifiedMessagingPage disableSecureRedirect={true} />;
};

export default MessagingPageWrapper;
